import { useMediaQuery } from "@mui/material";
import { ReactNode, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { scrollTo } from "../../../utils/scrollTo";
import Footer from "../footer";
import Header from "../header";
import MobileMenu from "../mobile-menu";
import PageBanner from "../page-banner";
import styles from "./styles.module.css";

interface MainLayoutProps {
  children: ReactNode;
}

const MainLayout = ({ children }: MainLayoutProps) => {

  const location = useLocation();
  const backgroundStyle = location.pathname === "/" ? styles["main-home-background"] : styles["main-background"];
  const [openMenu, setOpenMenu] = useState<boolean>(false);

  const isMobile = useMediaQuery("(max-width: 1130px)");
  const isHome = location.pathname === "/";

  useEffect(() => {
    setOpenMenu(false);
    scrollTo('main-layout-content');
  }, [location])

  return (
    <main id="main-layout-content" className={styles.content && backgroundStyle}>
      {isMobile ? <MobileMenu open={openMenu} switchOpenMenu={() => setOpenMenu(!openMenu)} /> : <Header />}
      {!openMenu && <div className={styles["main-content"] && backgroundStyle}>
        {!isHome && <PageBanner />}
        <div className={styles["page-content"]}>
          {children}
        </div>
      </div>}
      {!openMenu && <Footer />}
    </main>
  );
};

export default MainLayout;
